window.$OneSignal = window.OneSignal = window.OneSignal || [];

OneSignal.push(['init', {
  "appId": "2efafb05-1b5a-48d5-af7d-94056551cba2",
  "autoRegister": false,
  "allowLocalhostAsSecureOrigin": true,
  "welcomeNotification": {
    "disable": true
  },
  "notificationClickHandlerMatch": "origin",
  "notificationClickHandlerAction": "focus"
}]);

export default function (ctx, inject) {
  inject('OneSignal', OneSignal)
}
